import { useFeatureValue } from '@growthbook/growthbook-react';

export interface YogAdminFeature {
  enabled: boolean;
  events?: {
    eventId: string;
    allowedActions: string[];
  }[];
  [key: string]: any;
}

export const useYogAdminFeature = (): YogAdminFeature => {
  return useFeatureValue<YogAdminFeature>('sampark.yog-admin', {
    enabled: false
  });
};

export const useManageRegistrationFeature = ({ eventId }: { eventId: string }) => {
  const yogAdminFeature = useYogAdminFeature();
  const yogAdminActions = yogAdminFeature.events || [];
  const currentEvent = yogAdminActions.find((event) => event.eventId === eventId);
  return currentEvent;
};
